module.exports = __webpack_public_path__ + "img/guide1-3.6e273d48.png";